import React from "react";
import { Box, Grid } from "@material-ui/core";
import Heading from "./components/Heading";
import { ListVehicles } from "./ListVehicles";

type Props = {
  children?: React.ReactNode;
  index: any;
  value: any;
};

export function VehiclTab({ value, index, ...other }: Props): React.ReactElement {
  const pageHeading = "List of Vehicles";

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <Box borderColor="grey.200">
            <Heading heading={pageHeading} />
            <Box borderTop={2} mb={1} borderColor="grey.200"></Box>
            <Grid container direction="row">
              <Grid item xs={12} md={12}>
                <ListVehicles />
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </div>
  );
}
